// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Tx-z","smallCardRow":"Ux-z","largeCardRow":"Vx-z","productSearchRow":"Wx-z","curatedRow":"Xx-z"};